import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faQuestionCircle } from '@fortawesome/pro-solid-svg-icons/faQuestionCircle';
import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import PickupReminder from './pickup-reminder';
import Section from './section';
import ServiceCountSection from './service-count-section';
import PickupDetailsSection from './pickup-details-section';
import AddressSection from './address-section';
import RequestButton from './request-button';
import { Tooltip } from 'ui-components/components/tooltip';
import { TooltipContent } from 'ui-components/components/tooltip/tooltip-content';
import { getServiceCountArray } from '../constants';
import { FormattedMessage } from 'react-intl';

import style from './style.module.less';
import messages from '../messages';

const defaultPickupData = {
  futurePickup: {
    pickupDate: '',
  },
  todaysPickup: {},
};

const PickupPageContent = ({ shipFrom, pickupData = defaultPickupData, handleInputChange, requestPickup, cancelPickup }) => {
  const { todaysPickup, futurePickup } = pickupData;

  const address = {
    line1: shipFrom.line1,
    line2: shipFrom.line2,
    line3: `${shipFrom.city}, ${shipFrom.state} ${shipFrom.postalCode}`,
  };

  const hasPickupToday = !!todaysPickup.isSubmitted;
  const isDisabled = !!futurePickup.pickupRequestID;
  const headerText = isDisabled ? messages.alreadySecheduledPickupHeader : messages.schedulePickupHeader;

  return (
    <div className={style['pickup-content']}>
      {hasPickupToday && <PickupReminder serviceCounts={getServiceCountArray(todaysPickup)} todaysPickup={todaysPickup} />}
      <h3>
        <FormattedMessage {...headerText} /> {moment(futurePickup.pickupDate).format('dddd, MMM Do')}
      </h3>
      <div className={style.wrapper}>
        <Section childClassName='service-section' header={<FormattedMessage {...messages.serviceSectionHeader} />}>
          <ServiceCountSection isDisabled={isDisabled} onChange={handleInputChange} serviceCounts={getServiceCountArray(futurePickup)} />
        </Section>
        <Section childClassName='details-section' header={<FormattedMessage {...messages.detailsSectionHeader} />}>
          <PickupDetailsSection
            instructions={futurePickup.specialInstruction}
            isDisabled={isDisabled}
            onChange={handleInputChange}
            pickupLocation={futurePickup.pickupLocation}
            weight={futurePickup.totalWeightOZ}
          />
        </Section>
        <Section childClassName='address-section' header={<FormattedMessage {...messages.addressSectionHeader} />}>
          <AddressSection
            address={address}
            company={shipFrom.company || futurePickup.company}
            firstName={futurePickup.firstName}
            hasCompany={!!shipFrom.company}
            isDisabled={isDisabled}
            lastName={futurePickup.lastName}
            onChange={handleInputChange}
          />
        </Section>
        <RequestButton cancelPickup={cancelPickup} pickup={futurePickup} requestPickup={requestPickup} />
      </div>

      <div className={style['helper-text']}>
        <FormattedMessage
          {...messages.pickupHelperText}
          values={{
            lineBreak: <br />,
          }}
        />
        <Tooltip position='right'>
          <div className={style.tooltip}>
            <FontAwesomeIcon className={style['tooltip-icon']} icon={faQuestionCircle} />
          </div>
          <TooltipContent>
            <FormattedMessage {...messages.tooltipContent} />
          </TooltipContent>
        </Tooltip>
        <br />
        <span className={style['helper-text-bold']}>
          <FormattedMessage {...messages.boldHelperText} />
        </span>
      </div>
    </div>
  );
};

PickupPageContent.propTypes = {
  handleInputChange: PropTypes.func.isRequired,
  shipFrom: PropTypes.object.isRequired,
  pickupData: PropTypes.shape({
    futurePickup: PropTypes.object,
    todaysPickup: PropTypes.object,
  }),
  requestPickup: PropTypes.func.isRequired,
  cancelPickup: PropTypes.func.isRequired,
};

export default PickupPageContent;
